import api from './auth';

// User-facing tips endpoints
export const getAllTips = () => {
    return api.get('/api/tips/all');
};

export const getRandomTip = () => {
    return api.get('/api/tips/random');
};

export const getTipsByCategory = (categoryId) => {
    return api.get(`/api/tips/category/${categoryId}`);
};

export const getRandomTipByCategory = (categoryId) => {
    return api.get(`/api/tips/random/category/${categoryId}`);
};

// Admin-only endpoints
export const createTip = (tipData) => {
    return api.post('/api/tips', tipData);
};

export const updateTip = (tipId, tipData) => {
    return api.put(`/api/tips/${tipId}`, tipData);
};

export const deleteTip = (tipId) => {
    return api.delete(`/api/tips/${tipId}`);
};

export const uploadTipImage = (imageFile) => {
    const formData = new FormData();
    formData.append('file', imageFile);

    return api.post('/api/tips/upload', formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        }
    });
};

export const createTipWithImage = (tipData, imageFile) => {
    const formData = new FormData();

    // Add tip data as JSON blob
    formData.append('tip', new Blob([JSON.stringify(tipData)], {
        type: 'application/json'
    }));

    // Add image file
    formData.append('file', imageFile);

    return api.post('/api/tips/create-with-image', formData, {
        headers: {
            'Content-Type': 'multipart/form-data',
        }
    });
};

// Admin endpoint to get all tips including inactive ones
export const getAllTipsForAdmin = () => {
    return api.get('/api/tips/admin/all');
};
